import { useQuery } from '@tanstack/react-query';
import { useApi } from 'contexts/ApiContext';

import useRequiredParams from '@polyai/common/hooks/useRequiredParams';

import type api from 'api';
import { useGetApiConfigQueryKey } from 'hooks/api/apiConfig/hooks';
import type { QueryOptionsFor } from 'hooks/api/types';
import useFeatureSwitch from 'hooks/useFeatureSwitch/useFeatureSwitch';

export interface UseApiConfigOptions {
  options?: QueryOptionsFor<typeof api.getApiConfig>;
}

const useApiConfig = ({ options }: UseApiConfigOptions = {}) => {
  const { accountId } = useRequiredParams<{
    accountId: string;
  }>();

  const api = useApi();
  const { isFeatureOn } = useFeatureSwitch();

  const queryKey = useGetApiConfigQueryKey(accountId);

  return useQuery({
    queryKey,
    queryFn: () => api.methods.getApiConfig(accountId),
    enabled: isFeatureOn('agent_studio_data_access'),
    refetchOnWindowFocus: false,
    retry: false,
    ...options,
  });
};

export default useApiConfig;
